import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { getAsset } from '../../../../util/assets';

const propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  textClassName: PropTypes.string,
  activeStep: PropTypes.shape({
    title: PropTypes.node,
  }).isRequired,
  position: PropTypes.oneOf(['left', 'right', 'top', 'bottom']),
  icon: PropTypes.string,
  bubbleStyle: PropTypes.oneOf(['full']),
};

const WaldoBubble = ({
  children,
  className,
  textClassName,
  activeStep,
  position = 'right',
  icon = '/waldo-icon.svg',
  bubbleStyle,
}) => {
  const classes = classNames({
    'create-wizard-step-bubble-header': true,
    [`create-wizard-step-bubble-header-${position}`]: position,
    [`create-wizard-step-bubble-header-${bubbleStyle}`]: !!bubbleStyle,
    [className]: !!className,
  });

  const textClasses = classNames({
    'create-wizard-bubble': true,
    [textClassName]: !!textClassName,
  });

  if (!activeStep?.title) {
    return null;
  }

  return (
    <div data-testid="waldo-bubble" className={classes}>
      <div className="create-wizard-step-bubble-header-wrapper">
        <img
          src={getAsset(icon)}
          alt=""
          width="60"
          className="create-wizard-step-bubble-header-logo"
        />
        {activeStep.title && (
          <div className={textClasses}>
            <p>{activeStep.title}</p>
          </div>
        )}
      </div>
      {children}
    </div>
  );
};

WaldoBubble.propTypes = propTypes;

export default WaldoBubble;
